<script>
import { cityCodeJson } from "@/assets/js/city";
export default {
    name: "driverAuditForm",
    props: {
        rowData: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            cityList: cityCodeJson,
            driverClassAll: true, // 车主准驾车型全选
            driverClassChecked: false,
            useCharacterAll: false, // 车主使用性质全选
            useCharacterChecked: true,
            submitLoading: false,
            ruleForm: {
                age: 1,
                cityCode: "",
                driverMinAge: 20,
                driverMaxAge: 60,
                drivingAge: 1,
                driverClass: ["C1", "C2", "B1", "B2", "A1", "A2", "A3"],
                useCharacter: ["非营运", "营转非", "出租转非", "预约出租转非"],
                vehicleMaxLife: 10,
            },
            rules: {
                age: [{ required: true, trigger: "blur" }],
                driverMinAge: [
                    { required: true, message: "请输入车主最小年龄", trigger: "blur" },
                    { validator: this.validateDriverMinAge, trigger: "blur" },
                ],
                driverMaxAge: [
                    { required: true, message: "请输入车主最大年龄", trigger: "blur" },
                    { validator: this.validateDriverMaxAge, trigger: "blur" },
                ],
                driverClass: [
                    { required: true, message: "请选择准驾车型", trigger: "change" },
                ],
                useCharacter: [
                    { required: true, message: "请选择车辆使用性质", trigger: "change" },
                ],
                drivingAge: [
                    { required: true, message: "请输入车主最低驾龄", trigger: "blur" },
                ],
                vehicleMaxLife: [
                    { required: true, message: "请输入车辆最大年限", trigger: "blur" },
                ],
            },
            disabled: true,
            oldData: {}
        };
    },

    computed: {
        driverClassType() {
            return this.$const.DRIVERSHORTTYPE.map((item) => item.value);
        },
        useCharacterType() {
            return this.$const.USENATURE.map((item) => item.value);
        },
        city() {
            let arr = []
            this.cityList.forEach((pre) => {
                if (pre.districts) {
                    pre.districts.forEach((item) => {
                        arr.push(item)
                    })
                }
            })
            return arr
        },
    },

    watch: {
        rowData: {
            handler(newVal) {
                if (!newVal) return
                this.ruleForm = {
                    ...newVal,
                    driverClass: newVal.driverClass.split(","),
                    useCharacter: newVal.useCharacter.split(","),
                    age: 1,
                };
                this.oldData = {...this.ruleForm}
                this.driverClassCheck(this.ruleForm.driverClass)
                this.useCharacterCheck(this.ruleForm.useCharacter)
            },
        },
    },
    methods: {
        validateDriverMinAge(rule, value, callback) {
            if (value === "") {
                callback(new Error("请输入车主最小年龄"));
            } else if (value >= this.ruleForm.driverMaxAge) {
                callback(new Error("请小于最大年龄!"));
            } else {
                callback();
            }
        },
        validateDriverMaxAge(rule, value, callback) {
            if (value === "") {
                callback(new Error("请输入车主最大年龄"));
            } else if (value <= this.ruleForm.driverMinAge) {
                callback(new Error("请大于最小年龄!"));
            } else {
                callback();
            }
        },
        inputNumber(e, prop) {
            this.ruleForm[prop] = e.replace(/[^\d]/g, "");
            if (this.ruleForm[prop] !== '' && this.ruleForm[prop] < 1) {
                this.ruleForm[prop] = 1
            }
        },
        driverClassCheckAllChange(val) {
            console.log('val::: ', val);
            this.ruleForm.driverClass = val ? this.driverClassType : [];
            this.driverClassChecked = false;
        },
        useCharacterCheckAllChange(val) {
            console.log('val::: ', val);
            this.ruleForm.useCharacter = val ? this.useCharacterType : [];
            this.useCharacterChecked = false;
        },
        driverClassCheck(value) {
            console.log('value::: ', value);
            let checkedCount = value.length;
            this.driverClassAll = checkedCount === this.driverClassType.length;
            this.driverClassChecked =
                checkedCount > 0 && checkedCount < this.driverClassType.length;
        },
        useCharacterCheck(value) {
            console.log('value::: ', value);
            let checkedCount = value.length;
            this.useCharacterAll = checkedCount === this.useCharacterType.length;
            this.useCharacterChecked =
                checkedCount > 0 && checkedCount < this.useCharacterType.length;
        },

        sure() {
            this.$refs.ruleForm.validate(async (valid) => {
                if (valid) {
                    this.submitLoading = true;
                    let params = this.$utils.deepCopyFn(this.ruleForm);
                    params.driverClass = params.driverClass.join(",");
                    params.useCharacter = params.useCharacter.join(",");
                    params.cityName = this.city.find(
                        (item) => item.citycode === params.cityCode
                    ).name;
                    delete params.age;
                    const url = "/api/v1/manage/driverAndVehicle/audit/config";
                    const { code } = await this.$axios.post(url, params);
                    if (code === 1) {
                        this.$message.success("保存成功");
                        this.disabled = true;
                        this.$emit('refresh')
                    }
                    this.submitLoading = false;
                }
            });
        },
        handClose() {
            this.disabled = true;
            this.ruleForm = {...this.oldData}
        },
    },
};
</script>
<template>
    <div class="driverAuditForm">
        <div class="flex-between">
            <div class="formTitle">认证规则</div>
            <el-button type="primary" v-if="disabled" @click="disabled = false">编辑</el-button>
            <div v-else>
                <el-button @click="handClose">取消</el-button>
                <el-button type="primary" @click="sure" :loading="submitLoading">保存</el-button>
            </div>
        </div>
        <div class="blueInfo flex">
            <i class="el-icon-warning" style="color: #409EFF;font-size: 16px; margin-right: 8px;"></i>
            <span>以下车主认证规则仅适用于当前城市接单的车主，未单独配置车主认证规则的城市采用默认规则</span>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" :disabled="disabled">
            <el-form-item label="车主年龄范围" prop="age" style="margin-bottom: 0;"> 
                <el-form-item prop="driverMinAge" style="display: inline-block; width: 229px;">
                    <el-input v-model="ruleForm.driverMinAge" :maxlength="3"
                        @input="inputNumber($event, 'driverMinAge')">
                        <template slot="append">岁</template>
                    </el-input>
                </el-form-item>
                <span> 至 </span>
                <el-form-item prop="driverMaxAge" style="display: inline-block; width: 229px;">
                    <el-input v-model="ruleForm.driverMaxAge" :maxlength="3"
                        @input="inputNumber($event, 'driverMaxAge')">
                        <template slot="append">岁</template>
                    </el-input>
                </el-form-item>
            </el-form-item>
            <el-form-item label="车主最低驾龄" prop="drivingAge">
                <el-input v-model="ruleForm.drivingAge" :maxlength="3" @input="inputNumber($event, 'drivingAge')">
                    <template slot="append">年</template>
                </el-input>
            </el-form-item>
            <el-form-item label="车主准驾车型" prop="driverClass">
                <el-checkbox :indeterminate="driverClassChecked" v-model="driverClassAll"
                    @change="driverClassCheckAllChange">全部
                </el-checkbox>
                <el-checkbox-group @change="driverClassCheck" v-model="ruleForm.driverClass">
                    <el-checkbox v-for="item in $const.DRIVERSHORTTYPE" :key="item.value" :label="item.value">{{
                        item.label
                        }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="车辆使用性质" prop="useCharacter">
                <el-checkbox :indeterminate="useCharacterChecked" v-model="useCharacterAll"
                    @change="useCharacterCheckAllChange">全部
                </el-checkbox>
                <el-checkbox-group @change="useCharacterCheck" v-model="ruleForm.useCharacter">
                    <el-checkbox v-for="item in $const.USENATURE" :key="item.value" :label="item.value">{{ item.label
                        }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>

            <el-form-item label="车辆最大年限" prop="vehicleMaxLife">
                <el-input v-model="ruleForm.vehicleMaxLife" :maxlength="3"
                    @input="inputNumber($event, 'vehicleMaxLife')">
                    <template slot="append">年</template>
                </el-input>
            </el-form-item>
        </el-form>
    </div>
</template>


<style scoped lang="less">
.driverAuditForm {
    max-width: 700px;

    .flex-between {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        
        .formTitle {
            font-size: 16px;
            font-weight: 600;
            color: #303133;
        }
        
        .el-button {
            min-width: 80px;
            border-radius: 6px;
        }
    }

    .blueInfo {
        margin-bottom: 20px;
        padding: 12px 16px;
        background: #f0f7ff;
        border-radius: 8px;
        font-size: 13px;
        color: #606266;
        line-height: 1.5;
    }

    /deep/ .el-form {
        .el-form-item {
            margin-bottom: 20px;
            
            .el-form-item__label {
                font-weight: 500;
                color: #606266;
            }
        }
        
        .el-input {
            max-width: 480px;
        }
        
        .el-input__inner {
            border-radius: 6px;
        }
        
        .el-input-group__append,
        .el-input-group__prepend {
            background-color: #F5F7FA !important;
            border-radius: 0 6px 6px 0;
        }
        
        .el-checkbox-group {
            display: flex;
            flex-wrap: wrap;
            gap: 8px 20px;
            margin-top: 8px;
            
            .el-checkbox {
                margin-right: 0;
            }
        }
    }
}
</style>